<template>
  <section class="sme-underwriting">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <template>
        <div class="abs-top-right">
          <!--          <v-button @click="handlerBack">Save Quote</v-button>-->
          <v-button @click="handlerBack">Back</v-button>
          <v-button
            type="btn-primary"
            @click="handlerNext(3)">Next</v-button>
        </div>
      </template>
      <div class="underwriting-container">
        <div class="form-half-330">
          <template v-if="step==0">
            <h3 class="color-dark">Basic Information</h3>
            <div class="form-item">
              <span>Business Nature</span>
              <el-form-item
                :rules="rules.select"
                prop="basic_info.bus_nature"
              >
                <v-select
                  v-model="formData.basic_info.bus_nature"
                  :block="true"
                  :list="smeOptions.business_nature" />
              </el-form-item>
            </div>

            <div class="form-item">
              <span>Is it open for 24 hours?</span>
              <el-form-item
                :rules="rules.select"
                prop="basic_info.bus_hour_24">
                <v-radio-group
                  v-model="formData.basic_info.bus_hour_24"
                  :block="true"
                  :list="smeYesNoOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Floor Area of Seated:</span>
              <el-form-item
                :rules="rules.input"
                prop="basic_info.fl_area_of_seat"
              >
                <v-input
                  v-model="formData.basic_info.fl_area_of_seat"
                  :int="true"
                  :key-number="true"
                  maxlength="4"
                  append="sq. ft." />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Floor Area of Workspace:</span>
              <el-form-item
                :rules="rules.input"
                prop="basic_info.fl_area_of_work"
              >
                <v-input
                  v-model="formData.basic_info.fl_area_of_work"
                  maxlength="4"
                  :int="true"
                  :key-number="true"
                  append="sq. ft." />
              </el-form-item>
            </div>
            <div class="form-item">
              <span class="sme--content__tip ">
                #Exclude terrace / extended outdoor building structure
              </span>
            </div>
            <div class="form-item">
              <span>Total Floor Area:</span>
              <el-form-item
              >
                <v-input
                  :value="total_area"
                  disabled
                />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>No. of Seats</span>
              <el-form-item
                ref="basic_info.no_of_seats"
                prop="basic_info.no_of_seats"
                :rules="rules.no_of_seats"
              >
                <v-input
                  v-model="formData.basic_info.no_of_seats"
                  :keyNumber="true"
                  :int="true"
                  maxlength="2"
                />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Cook with Fire or Non-Fire Cooking?</span>
              <el-form-item
                :rules="rules.select"
                prop="basic_info.cook_with_fire_ind">
                <v-radio-group
                  v-model="formData.basic_info.cook_with_fire_ind"
                  :block="true"
                  :list="smeOptions.pl_cook_with_fire" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Any claim history in the past 3 years?</span>
              <el-form-item
                :rules="rules.select"
                prop="basic_info.claim_history_ind">
                <v-radio-group
                  v-model="formData.basic_info.claim_history_ind"
                  :block="true"
                  :list="smeYesNoOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Have you ever been declined, refused to renew or renewed but subject to special terms or conditions for similar insurance?</span>
              <el-form-item
                :rules="rules.select"
                prop="basic_info.reject_ind">
                <v-radio-group
                  v-model="formData.basic_info.reject_ind"
                  :block="true"
                  :list="smeYesNoOptions" />
              </el-form-item>
            </div>
          </template>
          <template v-if="step==1">
            <h3 class="color-dark">Contents Details</h3>
            <div class="form-item">
              <span>What is sum insured of Contents? (Including furniture, fixtures, fittings, machinery & equipment)</span>
              <el-form-item
                :rules="rules.input"
                prop="content_detail.contents_isrd">
                <v-input
                  v-model="formData.content_detail.contents_isrd"
                  :keyNumber="true"
                  :int="true"
                  maxlength="7"
                  prepend="HK$" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span class="sme--content__tip ">
                <!--                exclude designer decoration / plate glass-->
                Exclude articles brittle in nature / plate glass
              </span>
            </div>
            <div class="form-item">
              <span>Any stock to be insured?</span>
              <el-form-item
                :rules="rules.select"
                prop="content_detail.stocks_ind">
                <v-radio-group
                  v-model="formData.content_detail.stocks_ind"
                  :block="true"
                  :list="smeYesNoOptions" />
              </el-form-item>
            </div>
            <div
              v-if="formData.content_detail.stocks_ind!=2"
              class="form-item">
              <span>What is the sum insured of stock?</span>
              <el-form-item
                prop="content_detail.stocks_isrd">
                <v-input
                  v-model="formData.content_detail.stocks_isrd"
                  :keyNumber="true"
                  :int="true"
                  :max="stocks_isrd_max"
                  prepend="HK$"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span class="sme--content__tip ">
                Exclude stock of goods on consignment
              </span>
            </div>
          </template>
          <template v-if="step==2">
            <h3 class="color-dark">Public Liability Details</h3>
            <div class="form-item">
              <span>Sum Insured of public liability</span>
              <el-form-item>
                <v-input
                  disabled
                  :value="public_liability"
                  prepend="HK$" />
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span class="sme&#45;&#45;content__tip ">-->
              <!--                # If there is any outdoor signboard hanged up over 30 feet from floor level, please contact our customer services representatives.              </span>-->
              <span class="sme--content__tip ">
                The quote may not be applicable if there is any outdoor signboard hanged up over 30 feet from floor level, please contact our Customer Service Representatives for further enquiry.              </span>
            </div>
          </template>
        </div>
        <div
          v-if="step==3"
          class="form-half-7">
          <occuption-underwriting
            ref="occuption"
            :content-title="'Catering staff'"></occuption-underwriting>
        </div>
      </div>
      <template>
        <div class="abs-bottom-right">
          <!--          <v-button @click="handlerBack">Save Quote</v-button>-->
          <v-button @click="handlerBack">Back</v-button>
          <v-button
            type="btn-primary"
            @click="handlerNext(3)">Next</v-button>
        </div>
      </template>
    </el-form>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinSME from '@/mixins/sme'
import occuptionUnderwriting from '../component/occuption-underwriting'

export default {
  name: 'cateringUnderwriting',
  components:{
    occuptionUnderwriting
  },
  mixins: [MixinOptions, MixinRules,MixinSME],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        basic_info:{
          bus_nature:null,
          bus_hour_24:null,
          fl_area_of_seat:null,
          fl_area_of_work:null,
          no_of_seats:null,
          cook_with_fire_ind:null,
          claim_history_ind:null,
          reject_ind:null
        },
        content_detail:{
          contents_isrd:null,
          stocks_ind:null,
          stocks_isrd:0
        },
        pl_detail:{

        },
      },
    }
  },
  computed: {

  },
  watch: {
  },
}
</script>
<style lang="scss" scoped>
@import "../underwriting";
</style>
